import React, { useEffect, useState, useContext } from 'react';
import { Dialog, DialogTitle, DialogActions, Button, Box, } from '@material-ui/core';
import { i18n } from '../../translate/i18n';
import { makeStyles } from "@material-ui/core/styles";
import api from "../../services/api";
import { Can } from "../Can";

import { AuthContext } from "../../context/Auth/AuthContext";
import * as XLSX from "xlsx";
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import toastError from '../../errors/toastError';
const useStyles = makeStyles((theme) => ({
  multFieldLine: {
    display: "flex",
    // "& > *:not(:last-child)": {
    //   marginRight: theme.spacing(1),
    // },
    marginTop: 8,
  },
  uploadInput: {
    display: "none",
  },

  btns: {

    margin: 15,

  },
  label: {
    padding: 18,
    width: "100%",
    textTransform: 'uppercase',
    display: 'block',
    marginTop: 10,
    border: "solid 2px grey",
    textAlign: 'center',
    cursor: 'pointer',
    borderRadius: 8

  },

}));

const ContactImportWpModal = ({ isOpen, handleClose, selectedTags, hideNum, userProfile }) => {
  const classes = useStyles();
  const { user } = useContext(AuthContext);
  const history = useHistory();

  const initialContact = { name: "", number: "", error: "" }

  const [contactsToImport, setContactsToImport] = useState([])
  const [statusMessage, setStatusMessage] = useState("")
  const [currentContact, setCurrentContact] = useState(initialContact)

  const handleClosed = () => {
    setContactsToImport([])
    setStatusMessage("")
    setCurrentContact(initialContact)
    handleClose()
  }

  useEffect(() => {
    console.log(contactsToImport?.length)
    if (contactsToImport?.length) {
      contactsToImport.map(async (item, index) => {
        setTimeout(async () => {
          try {
            if (index >= contactsToImport?.length - 1) {
              setStatusMessage(i18n.t("contactImportWpModal.status.success"))
              //setContactsToImport([])
              setCurrentContact(initialContact)

              setTimeout(() => {
                handleClosed()
              }, 15000);
            }
            if (index % 5 === 0) {

              setStatusMessage(i18n.t("contactImportWpModal.status.inProgress", { index, total: contactsToImport?.length }))
              // toast.info(
              // );
            }
            console.log("antes do import: ", item[0])
            await api.post(`/contactsImport`, {
              marca: item.marca,
              conexion: item.conexion,
              name: item.name || item.nombre,
              number: item.number ? item.number.toString() : (item.numero ? item.numero.toString() : ""),
              email: item.email || item.correo,
              birthDate: item.birthDate || item.cumpleaños,
              tags: item.tags || item.etiqueta,
              carteira: item.carteira,
              kanbanBoard: item.tablero || item.kanbanBoard,
              kanbanLane: item.etapa || item.kanbanLane,
              agente: item.agente,
              queue: item.fila || item.queue,
            });

            setCurrentContact({ name: item.name || item.nombre, number: item.number || item.numero, error: "success" })
          } catch (err) {
            setCurrentContact({ name: item.name || item.nombre, number: item.number || item.numero, error: err })
          }
        }, 330 * index);
      });
    }
  }, [contactsToImport]);

  const handleOnExportContacts = async (model = false) => {
    const allDatas = []; //const { data } = await api.get("/contacts");

    let i = 1;
    if (!model) {
      while (i !== 0) {
        const { data } = await api.get("/contacts/", {
          params: { searchParam: "", pageNumber: i, contactTag: JSON.stringify(selectedTags) },
        });
        console.log(data)
        data.contacts.forEach((element) => {
          const tagsContact = element?.tags?.map(tag => tag?.name).join(', ');
          // Extrair carteira (email do usuário responsável)
          const carteira = element?.contactWallets && element.contactWallets.length > 0
            ? element.contactWallets[0].wallet?.email
            : "";
          const contactWithTags = { ...element, tags: tagsContact, carteira };
          allDatas.push(contactWithTags);
        });

        const pages = data?.count / 20;
        i++;
        if (i > pages) {
          i = 0;
        }
      }
    } else {
      allDatas.push({
        marca: "BotMix",
        conexion: "WhatsApp 1",
        fila: "Atención General",
        agente: "Nombre del Agente",
        nombre: i18n.t("contactImportWpModal.excel.modelName") || "Juan Pérez",
        numero: "51999999999",
        tablero: "Ventas",
        etapa: "Nuevo Lead",
        etiqueta: "VIP",
        correo: "contacto@ejemplo.com",
        cumpleaños: "1990-05-15",
      });
    }

    const exportData = allDatas.map((e) => {
      return {
        marca: e.marca || e.whatsapp?.brand?.name || "",
        conexion: e.conexion || e.whatsapp?.name || "",
        fila: e.fila || e.queue?.name || "",
        agente: e.agente || e.user?.name || "",
        nombre: e.nombre || e.name || "",
        numero: (hideNum && userProfile === "user" ? e.isGroup ? (e.numero || e.number) : (e.numero || e.number).slice(0, -6) + "**-**" + (e.numero || e.number).slice(-2) : (e.numero || e.number)),
        tablero: e.tablero || "",
        etapa: e.etapa || "",
        etiqueta: e.etiqueta || e.tags || "",
        correo: e.correo || e.email || "",
        cumpleaños: e.cumpleaños || e.birthDate || "",
      };
    });
    let wb = XLSX.utils.book_new();
    let ws = XLSX.utils.json_to_sheet(exportData);
    XLSX.utils.book_append_sheet(wb, ws, i18n.t("contactImportWpModal.excel.sheetName"));
    XLSX.writeFile(wb, i18n.t("contactImportWpModal.excel.fileName"));
  };

  const handleImportChange = (e) => {
    const [file] = e.target.files;
    const reader = new FileReader();

    reader.onload = (evt) => {
      try {
        const bstr = evt.target.result;
        const wb = XLSX.read(bstr, { type: "binary" });
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        const data = XLSX.utils.sheet_to_json(ws);
        setContactsToImport(data)
      } catch (err) {
        console.log(err);
        setContactsToImport([]);
      }
    };
    reader.readAsArrayBuffer(file);
  };
  
  const handleimportContact = async () => {
    try {
      history.push('/contacts/import');
    } catch (err) {
      toastError(err);
    }
  };

  return (
    <Dialog fullWidth open={isOpen} onClose={handleClosed}>
      <DialogTitle>{i18n.t("contactImportWpModal.title")}</DialogTitle>
      <div>
        <Box style={{ padding: "0px 10px 10px" }} >
          <Can
            role={user.profile}
            perform="contacts-page:deleteContact"
            yes={() => (
              <div className={classes.multFieldLine}>
                <Button
                  fullWidth
                  size="small"
                  color="primary"
                  variant="contained"
                  onClick={() => handleOnExportContacts(false)}
                >
                  {i18n.t("contactImportWpModal.buttons.export")}
                </Button>
              </div>
            )}
          />
          <div className={classes.multFieldLine}>
            <Button
              fullWidth
              size="small"
              color="primary"
              variant="contained"
              onClick={() => handleOnExportContacts(true)}
            >
              {i18n.t("contactImportWpModal.buttons.downloadModel")}
            </Button>
          </div>
          <div className={classes.multFieldLine}>
            <Button
              fullWidth
              size="small"
              color="primary"
              variant="contained"
              onClick={() => handleimportContact()}
            >
              {i18n.t("contactImportWpModal.buttons.import")}
            </Button>
          </div>
          
          {(user.companyId?.toString() === "153" || user.profile === "admin") && (
            <>
              <div className={classes.multFieldLine} style={{ marginTop: '20px' }}>
                <Button
                  fullWidth
                  size="small"
                  style={{ backgroundColor: '#10b981', color: 'white' }}
                  variant="contained"
                  onClick={() => handleOnExportContacts('dashboard')}
                >
                  {i18n.t("contactImportWpModal.buttons.downloadModelDashboard")}
                </Button>
              </div>
              <div className={classes.multFieldLine}>
                <Button
                  fullWidth
                  size="small"
                  style={{ backgroundColor: '#3b82f6', color: 'white' }}
                  variant="contained"
                  onClick={() => handleimportContact()}
                >
                  {i18n.t("contactImportWpModal.buttons.importDashboard")}
                </Button>
              </div>
            </>
          )}

        </Box>
      </div>

      <DialogActions>
        <Button onClick={handleClose} color="primary">
          {i18n.t("contactImportWpModal.buttons.closed")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ContactImportWpModal;
